<template>
  <section id="user_settings" class="box" v-if="loaded">
    <Popup v-if="showDialog" v-model="showDialog">
      <template #title> תנאי שימוש ומדיניות הפרטיות </template>
      <template #content>
       <div v-html="terms"></div>
      </template>
      <template #actions>
        <button class="btn" @click="showDialog=false">אישור</button>
      </template>
    </Popup>
    <h1 class="dashboard_title" v-html="get_word('RequirdDetails')"></h1>
    <ul class="setting_list">
        <li class="secondary" v-if="inSettings('display_name')">
            <label for="record_calls_mail" v-html="get_word('_NAME_')"></label>
            <input :placeholder="get_word('insert_mail')" required type="text" v-model="settings.display_name">
        </li>
        <li class="secondary" v-if="inSettings('phone')">
            <label for="phone" v-html="get_word('phone')"></label>
            <input id="phone" required type="text" v-model="settings.phone">
        </li>
        <li class="secondary" v-if="inSettings('email')">
            <label for="email" >אימייל</label>
            <input id="email" required type="text" v-model="settings.username">
        </li>
        <li class="secondary" v-if="inSettings('is_bride')">
            <div class="check">
                <label class="checkbox" >
                    <input type="checkbox" @input="show_wedding_date = !show_wedding_date;settings.is_bride = !settings.is_bride">
                    <span> {{ get_word('fresh_bride') }}</span>
                </label>
            </div>
            <template v-if="show_wedding_date">
                <label for="record_calls_mail">תאריך חתונה</label>
                <input type="date" v-model="settings.wedding_date">
            </template>
            <div class="add" v-if="show_wedding_date">
                <label v-text="get_word('bride_pic')"></label>
                <div class="pic_wrapper">
                    <div
                        class="pic"
                        :style="
                            pic_url != '' && !pic_loaded
                                ? 'background-image:url(' + pic_url + ')'
                                : 'background-image:#ccc'
                        "
                    >
                        <input
                            id="fileUpload"
                            type="file"
                            ref="file"
                            hidden
                            @change="uploadFile"
                        />
                        <div v-show="pic_loaded" class="progress-bar">
                            <div class="progress-fill"></div>
                        </div>
                    </div>
                    <div class="wrapper">
                        <div v-show="!pic_loaded && pic_url == ''">
                            <a @click="chooseFiles()">
                                {{ get_word("add_pic") }} <i class="fas fa-plus"></i
                            ></a>
                        </div>
                        <div v-show="!pic_loaded && pic_url != ''">
                            <a @click="chooseFiles()">
                                {{ get_word("change_pic") }} <i class="fas fa-edit"></i
                            ></a>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="secondary" v-if="inSettings('mikve_id')">
            <label v-html="get_word('favorite_mikve')"></label>
            <div class="wrapper">
                <span v-if="settings.mikve_name && settings.mikve_name !=''">{{settings.mikve_name}}</span>
                <button @click="showMikeList = true" class="btn" v-html="get_word((settings.mikve_name && settings.mikve_name !='' ? 'change' :'choose'))"></button>
            </div>

            <mikveList v-if="showMikeList" @close="showMikeList = false" v-model:mikveId="settings.mikve_id" v-model:mikveName="settings.mikve_name" />

        </li>
          <div class="checkbox_wrapper">
                <input class="styled_input" type="checkbox" id="checkbox" v-model="isApprove"  required/>
                <label >אני מאשר/ת את <a @click="showDialog = true">תנאי השימוש ומדיניות הפרטיות</a></label>
            </div>
       
        <button @click="saveSettings" class="btn" v-html="get_word('save_changes')"></button>
    </ul>

  </section>
</template>

<script>
import mikveList from '@/views/mikveList.vue';
import axios from "axios";
import Popup from "@/views/popup.vue"

export default {
    components:{mikveList,Popup},
    props:["RequirdDetails"],
    data() {
        return {
            isApprove: false,		
            loaded: false,		
            showDialog: false,		
            pic_url:'',
            terms:'',
            pic:0,
            pic_loaded: false,
            show_wedding_date: false,
            settings: {},
            mikves: [],
            showMikeList: false,
        }
    },
    mounted(){

        this.api({ action: 'get_settings'}, (data)=> {
            this.settings = data.data;
            this.settings.is_bride = 0;
            this.loaded = true;
        });
        this.api({ action: 'get_terms'}, (data)=>{
                if (data.data) {
                     this.terms = data.data;
                }
            });
        this.api({ action: 'get_mikves', data: {limit:false} }, (data)=>{
            this.mikves = data.data.items;
        });
    },
    computed: {
        words() {
        return this.$store.state.words
        },
        user() {
        return this.$store.state.user
        },
    },
    methods: {
        
        chooseFiles() {
			document.getElementById("fileUpload").click();
		},
		uploadFile(e) {
			let formData = new FormData();

			var headers = {
				"Content-Type": "multipart/form-data",
				Accept: "application/json",
			};

			this.pic_loaded = true;
			formData.append("file", e.target.files[0]);
			axios
				.post(window.api_url + "upload_pic", formData, {
					/*emulateJSON:true,*/ headers: headers,
				})
				.then(
					(response) => {
						if (response.data == "error") {
							this.alert("קרתה שגיאה נא לנסות שנית");
						}
						this.settings.pic = response.data.data.id;
						this.pic_url = response.data.data.url;
						this.pic_loaded = false;
					},
					(response) => {
						console.error(response.body);
					}
				);
		},
        inSettings(name)
        {
            for(let i in this.RequirdDetails)
            {
                if(this.RequirdDetails[i] == name) return true;
            }
            return false;
        },
        saveSettings() {

            // if(this.settings.is_bride && !this.settings.pic)
            // {
            //     this.$swal(this.get_word('pic_error'));
            //     return false;
            // }
            if (!this.isApprove) return this.alert(this.get_word('approve_terms'));

            this.api({action: 'save_settings',data: this.settings }, ()=>{
                this.$swal(this.get_word('saved_changes'));
                this.$emit('refresh_data');
            });
        },
        onSelectMikve(selectedMikve) {
            this.api({action: 'mikve/get',data: { id: selectedMikve.id } }, (data)=>{
                this.mikve = data.data;
            });
        },
    },
}
</script>

<style lang="scss">
.checkbox_wrapper{
    &{display: flex;align-items: center;gap:  10px;}
    label{font-weight: 500;margin-bottom: 0 !important;font-size: 15px !important;
        a{font-weight: 600;text-decoration: underline;}
    }
    label::after{content: "" !important}
    input{height: 20px !important;width: 20px !important;}
}
#user_settings {
    .pic_wrapper{display: flex;align-items: center; gap: 20px;}
    .pic{background: #ccc;height: 150px;background-position: center;background-size: cover;width: 150px;display: flex;justify-content: center;align-items: center;font-size: 30px;border-radius: 10px;position: relative;}

    h1{font-size: 32px;text-align: center;margin-bottom: 20px;}
    .setting_list {
        &{display: flex;flex-direction: column;gap: 20px;width: 100%;}

        li {
            &{display: flex;}
            &:not(:last-child){border-bottom: 1px solid #ccc;padding-bottom: 15px;}
            &.main{justify-content: space-between;align-items: center;}
            &.secondary{
                &{flex-direction: column;gap: 10px;}
                input{width: 100%;margin-bottom: 10px;}
            }
            
            label{
                &{display: block;font-size: 20px;}
                &::after{content:":"}
            }
        }            
    }

    .btn_primary{
        @media (max-width: 600px) {}
        @media (min-width: 600px) {margin-inline-start: auto;display: block;}
    }
}

</style>